const CustomRadioButton = ({ options = [], onChange, value, name }) => {
    const renderOptions = () => {
        return options.map((ele) => (
            <label className="d-flex align-items-center gap-sm" key={ele.value}>
                <input
                    id={`rb-${ele.value}`}
                    type='radio'
                    name={name}
                    value={ele.value}
                    disabled={ele.disabled}
                    checked={value === ele.value}
                    onChange={(e) => onChange(e.target.value)}
                />
                {ele.label}
            </label>
        ));
    };

    return (
        <div className="d-flex flex-column">
            {renderOptions()}
        </div>
    );
}

export default CustomRadioButton;